import { render } from "./nav-switch.vue?vue&type=template&id=7e1ad3ec&scoped=true"
import script from "./nav-switch.vue?vue&type=script&lang=ts"
export * from "./nav-switch.vue?vue&type=script&lang=ts"

import "./nav-switch.vue?vue&type=style&index=0&id=7e1ad3ec&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7e1ad3ec"

export default script